import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/base/Breadcrumb";
import { newsList } from "@/mocks/news";

export default function NewsDetailPage() {
  const { id } = useParams();
  const article = newsList.find((item) => item.id === id);
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2400);
    return () => window.clearTimeout(timer);
  }, [toast]);

  if (!article) {
    return (
      <div className="flex min-h-screen flex-col bg-background-50">
        <SiteHeader />
        <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
          <i className="ri-article-line text-4xl text-foreground-300"></i>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950">
            未找到该资讯文章
          </h1>
          <p className="mt-2 text-sm text-foreground-500">
            文章可能已被删除或链接有误。
          </p>
          <Link
            to="/news"
            className="mt-6 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            返回资讯列表
          </Link>
        </main>
        <SiteFooter />
      </div>
    );
  }

  const related = newsList.filter((item) => item.id !== article.id).slice(0, 4);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <title>{`${article.title} - 91看片影视资讯`}</title>
      <meta name="description" content={article.summary.slice(0, 150)} />
      <SiteHeader />

      <main className="flex-1">
        <div className="mx-auto max-w-site px-4 py-6 md:px-6 md:py-8">
          <Breadcrumb items={[{ label: "影视资讯", to: "/news" }, { label: article.title }]} />

          <div className="mt-6 grid grid-cols-1 gap-10 lg:grid-cols-3">
            {/* 正文 */}
            <article className="lg:col-span-2">
              <div className="flex flex-wrap gap-2">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded bg-accent-100 px-2 py-0.5 text-xs text-accent-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <h1 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
                {article.title}
              </h1>
              <div className="mt-4 flex flex-wrap items-center gap-4 border-b border-background-200 pb-4 text-sm text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {article.date}
                </span>
                <button
                  type="button"
                  onClick={() => setToast("分享链接已复制（演示）")}
                  className="ml-auto flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-share-forward-line"></i>
                  分享文章
                </button>
              </div>

              <div className="mt-6 h-[220px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[360px]">
                <img
                  src={article.cover}
                  alt={article.title}
                  title={`${article.title} - 91看片影视资讯`}
                  className="h-full w-full object-cover object-top"
                />
              </div>

              <div className="mt-6 space-y-5">
                {article.content.map((paragraph, i) => (
                  <p key={i} className="text-[15px] leading-8 text-foreground-700">
                    {paragraph}
                  </p>
                ))}
              </div>
            </article>

            {/* 侧栏推荐 */}
            <aside className="lg:col-span-1">
              <div className="sticky top-24 rounded-lg border border-background-200 bg-background-50 p-5">
                <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-fire-line text-accent-500"></i>
                  相关推荐资讯
                </h2>
                <div className="mt-4 flex flex-col divide-y divide-background-200">
                  {related.map((item) => (
                    <Link
                      key={item.id}
                      to={`/news/${item.id}`}
                      className="group py-3 first:pt-0"
                    >
                      <h3 className="line-clamp-2 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                        {item.title}
                      </h3>
                      <span className="mt-1 block text-xs text-foreground-400">
                        {item.date}
                      </span>
                    </Link>
                  ))}
                </div>
                <Link
                  to="/news"
                  className="mt-4 flex items-center justify-center gap-1 rounded-md bg-background-100 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
                >
                  查看全部资讯
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </main>

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-[70] -translate-x-1/2 rounded-lg bg-foreground-950 px-4 py-3 text-sm text-background-50 animate-fade-up">
          {toast}
        </div>
      )}

      <SiteFooter />
    </div>
  );
}